import { useEffect, useState, useContext, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { AppContext } from '../../context/AppContext';
import NewChatIcon from '../../assets/icon-topic.svg?react';
import './style.scss';
import { ChatHistoryComponent } from './ChatHistoryComponent';
import OverlayTooltip from './UI/OverlayTooltip';
import AppStoreIcon from '../../assets/icon-app-dashboard.svg?react';
import { useNavigate } from 'react-router-dom';
import useElysiaStore from '@/app/elysia-store';
import FavouriteAppList from './FavouriteAppList';
import CloseLeftSidePanelIcon from '@/assets/icon-close-pane.svg?react';
import ElyisaIcon from '@/assets/Elysia-logo.svg?react';
import { CommonDropdown } from './UI/CommonDropdown';
import { AuthContext } from '@/context/AuthContext';

const ChatHistorySidebar = (props) => {
  const { startNewTopicChat } = props;
  const { isSideNavOpen, setIsSideNavOpen } = useContext(AppContext);
  const { profileInfo } = useContext(AuthContext);
  const isPrivateChat = useElysiaStore((state) => state.isPrivateChat);

  const [pathSession_id, setPathSession_id] = useState('');
  const locationPath = window.location.pathname;
  let pathname = '';
  const newChatRef = useRef<HTMLButtonElement | null>(null);
  const navigate = useNavigate();

  if (locationPath.indexOf('/session/') !== -1) {
    pathname = locationPath.substring(locationPath.lastIndexOf('/') + 1);
  }

  useEffect(() => {
    setPathSession_id(pathname);

    // close side navbar for smaller screens
    if (window.innerWidth < 960) {
      setIsSideNavOpen(false);
    }
    // eslint-disable-next-line
  }, [pathname]);

  const handleNewChatClick = () => {
    if (window.innerWidth < 1260) {
      setIsSideNavOpen(false);
    }
    startNewTopicChat();
  };

  const handleAppDashboard = () => {
    if (window.innerWidth < 1260) {
      setIsSideNavOpen(false);
    }
    navigate('/app-store');
  };

  return (
    <>
      <div className={'menu-fixed-top' + (isSideNavOpen ? '' : ' d-none')}>
        <div className="menu-header d-flex justify-content-between align-items-center">
          <Button className="sidebar-logo" onClick={handleNewChatClick}>
            <ElyisaIcon />
          </Button>
          <OverlayTooltip
            tooltipText="Close Side Panel"
            buttonContent={<CloseLeftSidePanelIcon />}
            ariaLabel="back"
            testId="close-side-panel-button"
            tooltipClassName="tooltip-sidebar"
            buttonClassName="close-sidebar-pane d-flex"
            onClick={() => setIsSideNavOpen(!isSideNavOpen)}
          />
        </div>

        <Button
          data-testid="new-chat-button"
          className="new-chat-button fw-semibold"
          onClick={handleNewChatClick}
          ref={newChatRef}
        >
          <NewChatIcon />
          <span>New Chat</span>
        </Button>

        <Button
          data-testid="app-store-button"
          className="new-chat-button fw-semibold"
          onClick={handleAppDashboard}
        >
          <AppStoreIcon />
          <span>AI App Store</span>
        </Button>

        {/* Favourite App List */}
        <FavouriteAppList setIsSideNavOpen={setIsSideNavOpen} />

        <div className="chat-history-title-wrapper d-flex align-items-center justify-content-between">
          <span className={'fw-semibold' + (isPrivateChat ? ' private-chat-mode' : '')}>
            Chat History
          </span>
        </div>
      </div>
      <div
        className={
          'menu-scrollable flex-grow-1 overflow-auto' +
          (isSideNavOpen ? '' : ' d-none') +
          (isPrivateChat ? ' private-chat-mode' : '')
        }
      >
        <ChatHistoryComponent
          pathSession_id={pathSession_id}
          setPathSession_id={setPathSession_id}
        />
      </div>
      <div
        className={
          'menu-fixed-bottom' +
          (isSideNavOpen ? '' : ' d-none') +
          (isPrivateChat ? ' private-chat-mode' : '')
        }
      >
        {/* <div className="archive-msg" data-testid="archive-message-text">
          Archive your chats to keep beyond 30 days
        </div> */}

        <div className="mt-auto d-flex">
          <CommonDropdown {...props.config.logoutMenu} />
          <div className="d-flex flex-column m-0 gap-0">
            <p className="mb-0">{profileInfo?.fullName}</p>
            <p className=" text-break text-wrap mb-0">{profileInfo?.email}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatHistorySidebar;
